import React from 'react';
import PalQuizListPage from './PalQuizListPage';

const PracticePage = () => {
  return <PalQuizListPage title="Practice" quizType="Practice" basePath="/pal/practice" />;
};

export default PracticePage;
